import { SKELETON_ANIMATION } from '@/common/components/skeleton/skeleton';

const ShopItemHeaderSkelton = () => {
  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex gap-x-3">
        <div className={`h-12 w-12 rounded-xl ${SKELETON_ANIMATION}`} />

        <div className="mt-1 flex flex-col gap-y-2">
          <div className={`h-4 w-24 rounded-md ${SKELETON_ANIMATION}`} />
          <div className={`h-4 w-36 rounded-md ${SKELETON_ANIMATION}`} />
        </div>
      </div>

      <div className={`h-9 w-9 rounded-md ${SKELETON_ANIMATION}`} />
    </div>
  );
};

export const ShopItemProductCardSkeleton = () => {
  return (
    <div className="flex w-full flex-col lg:w-[212px]">
      <div
        className={`h-[182px] w-[182px] rounded-2xl  lg:w-[212px] ${SKELETON_ANIMATION}`}
      />
      <div className={`mt-1.5 h-4 w-[80%] rounded-md ${SKELETON_ANIMATION}`} />
      <div
        className={`mr-auto mt-1.5 h-4 w-[50%] rounded-md ${SKELETON_ANIMATION}`}
      />
    </div>
  );
};

export const ShopItemSkeleton = ({ isMobile }: { isMobile: boolean }) => {
  return (
    <div className="flex h-auto w-full flex-col gap-y-4  ">
      <ShopItemHeaderSkelton />

      <div className="flex  w-full flex-row  flex-wrap justify-between gap-y-4 ">
        <ShopItemProductCardSkeleton />
        <ShopItemProductCardSkeleton />
        <ShopItemProductCardSkeleton />
        <ShopItemProductCardSkeleton />
        <ShopItemProductCardSkeleton />
        {isMobile && <ShopItemProductCardSkeleton />}
      </div>
    </div>
  );
};
